import React, { createContext, useState, useContext } from "react";
import _ from 'lodash'

export type Tip = {
    from:number,
    to:number
}

export type Vibration = number

export type Level = {
    tipAmount:Tip,
    reactionTime:number,
    vibrationPower:Vibration
}

type ControlPanelContextType = {
    levels:Level[]
    addLevel:()=>void;
    deleteLevel:(key:number)=>void;
}

export const ControlPanelContext = createContext<ControlPanelContextType>({
    levels: [],
    addLevel: function (): void {
        throw new Error("Function not implemented.");
    },
    deleteLevel: function (key: number): void {
        throw new Error("Function not implemented.");
    }
});

export const ControlPanelProvider = (props:any) => {

    const [levels, setLevels] = useState<Level[]>([
        {
            tipAmount:{
                from:5,
                to:5
            },
            reactionTime:10,
            vibrationPower:5
        },
        {
            tipAmount:{
                from:15,
                to:15
            },
            reactionTime:20,
            vibrationPower:5
        },
        {
            tipAmount:{
                from:30,
                to:30
            },
            reactionTime:30,
            vibrationPower:5
        },
        {
            tipAmount:{
                from:50,
                to:50
            },
            reactionTime:60,
            vibrationPower:10
        },
        {
            tipAmount:{
                from:100,
                to:100
            },
            reactionTime:60,
            vibrationPower:10
        },
        {
            tipAmount:{
                from:200,
                to:200
            },
            reactionTime:60,
            vibrationPower:15
        },
    ])

    const addLevel = () => {
         const newLevel:Level  = {
            tipAmount: {
                from:0,
                to:0
            },
            reactionTime:0,
            vibrationPower:5
         }

         const tempLevels = Array.from(levels);
         tempLevels.push(newLevel);
         setLevels(tempLevels)

    }

    const deleteLevel = (lvlKey:number) => {
        _.remove(levels, (ele, index)=>index == lvlKey)
        const newLevel = Array.from(levels)
        setLevels(newLevel)
    }

    return (
        <ControlPanelContext.Provider 
            value={{
                levels,
                addLevel,
                deleteLevel
            }}
        >
            {props.children}
        </ControlPanelContext.Provider>
    )
}
export const useControlPanel = () => useContext(ControlPanelContext);
